import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "d-flex align-start ga-6 flex-wrap" }
const _hoisted_3 = { class: "profile-photo" }
const _hoisted_4 = { class: "profile-fields" }
const _hoisted_5 = {
  key: 0,
  class: "text-body-2 text-warning mb-3"
}
const _hoisted_6 = { class: "d-flex align-center ga-2 flex-wrap" }
const _hoisted_7 = { class: "d-flex justify-end mt-4" }
const _hoisted_8 = { class: "profile-fields" }
const _hoisted_9 = { class: "text-body-2 text-grey mt-1" }
const _hoisted_10 = { class: "profile-fields" }
const _hoisted_11 = { class: "d-flex justify-end mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_page_header = _resolveComponent("ontos-page-header")!
  const _component_ontos_media_field = _resolveComponent("ontos-media-field")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_ontos_view_info = _resolveComponent("ontos-view-info")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_ontos_section = _resolveComponent("ontos-section")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_ontos_colored_value = _resolveComponent("ontos-colored-value")!
  const _component_ontos_base = _resolveComponent("ontos-base")!

  return (_openBlock(), _createBlock(_component_ontos_base, _mergeProps(_ctx.baseProps, { ref: "base" }), {
    default: _withCtx(() => [
      (_ctx.loaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_ontos_page_header, {
              title: _ctx.$tt('profile'),
              level: 1
            }, null, 8, ["title"]),
            _createVNode(_component_ontos_section, {
              title: _ctx.$tt('profile-identity'),
              divider: false
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_ontos_media_field, {
                      type: "image",
                      value: _ctx.photo,
                      label: _ctx.$tt('photo'),
                      "error-message": _ctx.photoError,
                      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.photo = $event))
                    }, null, 8, ["value", "label", "error-message"])
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    (_ctx.nameMissing)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$tt('profile-name-needed')), 1))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.name,
                      "onUpdate:modelValue": [
                        _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
                        _cache[2] || (_cache[2] = ($event: any) => (_ctx.nameError = ''))
                      ],
                      label: _ctx.$tt('name'),
                      autocomplete: "name",
                      class: "required",
                      "error-messages": _ctx.nameError
                    }, null, 8, ["modelValue", "label", "error-messages"]),
                    (_ctx.alias)
                      ? (_openBlock(), _createBlock(_component_ontos_view_info, {
                          key: 1,
                          title: _ctx.$tt('profile-alias')
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", null, "@" + _toDisplayString(_ctx.alias), 1)
                          ]),
                          _: 1
                        }, 8, ["title"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ontos_view_info, {
                      title: _ctx.$tt('email')
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.email), 1),
                          (_ctx.verified)
                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                key: 0,
                                size: "x-small",
                                variant: "flat",
                                color: "success"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$tt('auth.verified')), 1)
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_component_v_btn, {
                                key: 1,
                                variant: "text",
                                size: "x-small",
                                class: "profile-link",
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.resendVerification()))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$tt('auth.resend-verification')), 1)
                                ]),
                                _: 1
                              }))
                        ])
                      ]),
                      _: 1
                    }, 8, ["title"]),
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_v_btn, {
                        color: "primary",
                        size: "small",
                        disabled: !_ctx.changed,
                        loading: _ctx.isSaving,
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.save()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            start: "",
                            size: "small"
                          }, {
                            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                              _createTextVNode("mdi-content-save", -1)
                            ]))]),
                            _: 1
                          }),
                          _createTextVNode(" " + _toDisplayString(_ctx.$tt('save')), 1)
                        ]),
                        _: 1
                      }, 8, ["disabled", "loading"])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["title"]),
            _createVNode(_component_ontos_section, {
              title: _ctx.$tt('language')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_v_select, {
                    "model-value": _ctx.language,
                    items: _ctx.languages,
                    label: _ctx.$tt('language'),
                    loading: _ctx.isSaving,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.chooseLanguage($event)))
                  }, null, 8, ["model-value", "items", "label", "loading"])
                ])
              ]),
              _: 1
            }, 8, ["title"]),
            _createVNode(_component_ontos_section, {
              title: _ctx.$tt('access')
            }, {
              default: _withCtx(() => [
                (_ctx.access)
                  ? (_openBlock(), _createBlock(_component_ontos_colored_value, {
                      key: 0,
                      option: _ctx.accessOption(_ctx.access),
                      form: "chip"
                    }, null, 8, ["option"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$tt('profile-access-note')), 1)
              ]),
              _: 1
            }, 8, ["title"]),
            (_ctx.hasPassword)
              ? (_openBlock(), _createBlock(_component_ontos_section, {
                  key: 0,
                  title: _ctx.$tt('profile-security')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.currentPassword,
                        "onUpdate:modelValue": [
                          _cache[6] || (_cache[6] = ($event: any) => ((_ctx.currentPassword) = $event)),
                          _cache[7] || (_cache[7] = ($event: any) => (_ctx.passwordErrors.current = ''))
                        ],
                        label: _ctx.$tt('auth.current-password'),
                        type: "password",
                        autocomplete: "current-password",
                        "error-messages": _ctx.passwordErrors.current
                      }, null, 8, ["modelValue", "label", "error-messages"]),
                      _createVNode(_component_v_text_field, {
                        modelValue: _ctx.newPassword,
                        "onUpdate:modelValue": [
                          _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newPassword) = $event)),
                          _cache[9] || (_cache[9] = ($event: any) => (_ctx.passwordErrors.next = ''))
                        ],
                        label: _ctx.$tt('auth.new-password'),
                        type: "password",
                        autocomplete: "new-password",
                        class: "mt-2",
                        "error-messages": _ctx.passwordErrors.next
                      }, null, 8, ["modelValue", "label", "error-messages"]),
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_v_btn, {
                          color: "primary",
                          size: "small",
                          variant: "tonal",
                          loading: _ctx.isSaving,
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.changePassword()))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              start: "",
                              size: "small"
                            }, {
                              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                _createTextVNode("mdi-lock-reset", -1)
                              ]))]),
                              _: 1
                            }),
                            _createTextVNode(" " + _toDisplayString(_ctx.$tt('auth.change-password')), 1)
                          ]),
                          _: 1
                        }, 8, ["loading"])
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["title"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 16))
}